@if (state(); as state) {
  <app-organization-sidebar-layout>
    <app-page-header>
      <div class="flex flex-col gap-2.5">
        <div class="flex gap-3 items-center">
          <ui-button
            [iconOnly]="true"
            mode="outlined"
            class="flex-none"
            [routerLink]="['/organizations', organizationId(), 'energy-interfaces']"
          >
            <ng-icon name="heroArrowLeft" size="20" class="!block" />
          </ui-button>
          <app-page-title class="flex-1">
            @if (state.isLoading) {
              <ui-skeleton class="h-9 w-80 block rounded-full" />
            } @else if (state.data) {
              {{ state.data.label }}
            }
          </app-page-title>
        </div>
        <app-energy-interface-details-breadcrumb-nav
          [organizationId]="organizationId()"
          [energyInterfaceId]="energyInterfaceId()"
        />
      </div>
    </app-page-header>

    @if (!state.error && state.isLoading) {
      <app-nav-skeleton slot="sticky-header" />
    } @else if (state.data) {
      <app-energy-interface-details-nav slot="sticky-header" />
    }
    @if (!state.error) {
      <div class="flex flex-col gap-5">
        <div>
          <router-outlet />
        </div>
      </div>
    } @else {
      <app-error-page
        [error]="state.error"
        (clickBack)="router.navigate(['/organizations', organizationId(), 'energy-interfaces'])"
        class="block"
        style="height: calc(100vh - 20rem)"
      />
    }
  </app-organization-sidebar-layout>
}
